<script>
import Axios from "axios";
import Base from "@/components/RequestDetails/RequestLog.vue";

export default {
  name: "RequestLogNewTap",
  extends: Base,
  created() {
    this.$store.state.TaskDetailsDialog = false;
  },
  methods: {
    // Route-based request id (standalone log tab has no agent prop)
    getCurrentRequestId() {
      return Number(this.$route.params.id) || null;
    },

    parseGroupedHistoryPayload(payload) {
      const fallbackRequestId = this.getCurrentRequestId();

      if (payload && Array.isArray(payload.requests)) {
        return {
          currentRequestId: Number(payload.current_request_id) || fallbackRequestId,
          groups: payload.requests.map((group) => ({
            request_id: Number(group.request_id),
            history: Array.isArray(group.history) ? group.history : [],
          })),
        };
      }

      if (Array.isArray(payload)) {
        return {
          currentRequestId: fallbackRequestId,
          groups: fallbackRequestId
            ? [{ request_id: fallbackRequestId, history: payload }]
            : [],
        };
      }

      return { currentRequestId: fallbackRequestId, groups: [] };
    },

    get_request_logs() {
      const requestId = this.getCurrentRequestId();
      if (!requestId) {
        return;
      }

      this.loading = true;

      Axios.get(
        `${this.$store.state.url}/agent/Request/History-With-Notes/${requestId}`,
        { headers: this.request_headers() }
      )
        .then((response) => {
          const parsed = this.parseGroupedHistoryPayload(response.data.payload);

          this.currentRequestId = parsed.currentRequestId;
          this.requestGroups = parsed.groups;

          const currentIndex = this.requestGroups.findIndex((group) =>
            this.isCurrentRequest(group.request_id)
          );
          this.expandedPanel = currentIndex >= 0 ? currentIndex : 0;

          console.log(
            "[RequestLogNewTap] loaded",
            this.requestGroups.length,
            "request group(s), current:",
            this.currentRequestId
          );

          this.setBreadCrumbs(["الرئيسية", "الطلبات", "سجل الطلب"]);
        })
        .catch((err) => {
          console.log(
            "[RequestLogNewTap] fetch error",
            err?.response?.data?.message || err.message
          );
          this.showPopup("error", err?.response?.data?.message || "حدث خطأ أثناء تحميل السجل");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    to_task_content(taskId) {
      const url = this.$router.resolve({
        name: "admin_tickets_details",
        params: { ticeket: taskId[0] },
      }).href;
      window.open(url, "_blank");
    },

    to_supportRequest_details(requestId) {
      const url = this.$router.resolve({
        name: "help_desk",
        params: { id: requestId[0] },
      }).href;
      window.open(url, "_blank");
    },
  },
  watch: {
    "$route.params.id"(newId, oldId) {
      if (newId && newId !== oldId) {
        this.get_request_logs();
      }
    },
  },
};
</script>
